var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"lg":"6","offset-lg":"3"}},[_c('outside-township-form',{attrs:{"outside_township":_vm.outsideTownship},on:{"emitOutsideTownshipData":_vm.emitData}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }